import request from '../../axios/axiosconfig.js'

/**
 * 查询商户列表
 * @param {*} params 
 * @returns 
 */
export function getBsList(params) {
  return request({
    url: '/ps/businessList/getAllBusiness/',
    method: 'get',
    params: params,
    timeout: 20000
  })
}

/**
 * 查询vip申请
 * @param {*} params 
 * @returns 
 */
export function getAllVipModifyApply(params) {
  return request({
    url: '/ps/businessList/getAllVipModifyApply',
    method: 'get',
    params: params
  })
}

/**
 * 查询商户详情
 * @param {*} params 
 * @returns 
 */
export function getBsById(params) {
  return request({
    url: '/ps/businessList/getBsById/'+params,
    method: 'get'
  })
}

/**
 * 编辑商户信息
 * @param {*} params 
 * @returns 
 */
 export function updateBusiness(data) {
  return request({
    url: '/ps/businessList/updateBusiness',
    method: 'post',
    data: data
  })
}

/**
 * 导出商户信息
 * @param {*} params 
 * @returns 
 */
export function exportData(data){
  return request({
    url: '/ps/businessList/export',
    method: 'post',
    data: data
  })
}

/**
 * 审核vip申请
 * @param {*} params 
 * @returns 
 */
 export function approvalVipModifyApply(data){
  return request({
    url: '/ps/businessList/approvalVipModifyApply',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/usermanagement/bsList.js